var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('checkbox',{attrs:{"value":_vm.isFeatured},on:{"input":_vm.updateFeatured}},[_vm._v(_vm._s(_vm.$t('Featured Product')))])}
var staticRenderFns = []

export { render, staticRenderFns }